import { useEffect, useState } from 'react';
import { useRecordMyTrainingProgress } from './useTraining';

/** Drafts never count as graded attempts. Keep failed edits in this mounted form. */
export function useTrainingDraft<T>(progressId: string, field: string, initial: T, enabled = true) {
  const [local, setLocal] = useState<T | undefined>();
  const save = useRecordMyTrainingProgress();
  const [lastSaved, setLastSaved] = useState<T | undefined>();
  const value = local ?? initial;
  useEffect(() => {
    if (local === undefined || !enabled) return;
    const timer = setTimeout(() => save.mutate({ progressId, progressData: { [field]: local } }, { onSuccess: () => setLastSaved(local) }), 700);
    return () => clearTimeout(timer);
  }, [local, progressId, field, save.mutate, enabled]);
  const flush = async () => { if (enabled && local !== undefined) { await save.mutateAsync({ progressId, progressData: { [field]: local } }); setLastSaved(local); } };
  return { value, set: setLocal, flush, status: !enabled ? 'Preview only — nothing is saved' : save.isPending ? 'Saving draft…' : save.isError ? 'Draft could not be saved. Your edits are still here.' : local !== undefined && local !== lastSaved ? 'Unsaved draft changes…' : local !== undefined ? 'Draft saved' : 'Saved draft restored', error: save.isError };
}
